import { UnknownKeyValuePairs } from './types'
/**
 * Composition Selector.
 */
export const composition = (attributes: UnknownKeyValuePairs, translation: {[key: string]: string}): string => {
    const compositionAttributes = [
        { attr: 'composition', translation: 'Composition' },
        { attr: 'additives', translation: 'Additives' },
        { attr: 'analyticalcomponents', translation: 'AnalyticalComponents' },
    ]

    let composition = ''

    for(const key of compositionAttributes) {
        composition += attributes.core[key.attr] && attributes.core[key.attr] !== ''
            ? `<u>${translation[key.translation]}:</u><br /><p>${attributes.core[key.attr].replaceAll('\n', '<br />')}</p>`
            : ''
    }

    return composition
}
